import OuterImg from "../../../assets/images/sister-concern/prime-sweater/outer.png";
import SweaterImg from "../../../assets/images/sister-concern/prime-sweater/sweater.png";
import ScarfImg from "../../../assets/images/sister-concern/prime-sweater/scarf.png";
import KidsImg from "../../../assets/images/sister-concern/prime-sweater/kids.png";

import SferaLogo from "../../../assets/images/sister-concern/pole-star-fashion/logos/sfera.png";
import VertbaudetLogo from "../../../assets/images/sister-concern/pole-star-fashion/logos/vertbaudet.png";
import OrchestraLogo from "../../../assets/images/sister-concern/prime-sweater/logos/orchestra.png";
import OfftexLogo from "../../../assets/images/sister-concern/prime-sweater/logos/offtex.png";
import CarryLogo from "../../../assets/images/sister-concern/prime-sweater/logos/carry.png";
import HemaLogo from "../../../assets/images/sister-concern/prime-sweater/logos/hema.png";
import FlorealParisLogo from "../../../assets/images/sister-concern/prime-sweater/logos/floreal.png";
import DanJohnLogo from "../../../assets/images/sister-concern/prime-sweater/logos/danjohn.png";
import DooaLogo from "../../../assets/images/sister-concern/prime-sweater/logos/dooa.png";
import Emporio88Logo from "../../../assets/images/sister-concern/prime-sweater/logos/emporio.png";
import PiazaItaliaLogo from "../../../assets/images/sister-concern/prime-sweater/logos/piaza.png";
import ZebraLogo from "../../../assets/images/sister-concern/prime-sweater/logos/zebra.png";
import MisterladyLogo from "../../../assets/images/sister-concern/prime-sweater/logos/misterlady.png";
import JeansLogo from "../../../assets/images/sister-concern/prime-sweater/logos/jeans.png";
import JohnLewisLogo from "../../../assets/images/sister-concern/prime-sweater/logos/john-lewis.png";
import SorbinoLogo from "../../../assets/images/sister-concern/prime-sweater/logos/sorbino.png";
import SuvariLogo from "../../../assets/images/sister-concern/prime-sweater/logos/suvari.png";
import CorsoDaLogo from "../../../assets/images/sister-concern/prime-sweater/logos/corso-da-vinci.png";
import JeronimoLogo from "../../../assets/images/sister-concern/prime-sweater/logos/jeronimo.png";

export const mainProductContent = {
  title: "Main Products",
  outerImage: OuterImg,
  arr: [
    {
      img: SweaterImg,
      innerTitle: "Sweater, Pullover, and Cardigan",
    },
    {
      img: ScarfImg,
      innerTitle: "Scarf and Caps",
    },
    {
      img: KidsImg,
      innerTitle: "Men, Women, and Kids",
      innerText: "Basic & Jacquard Design & Fancy styles",
    },
  ],
};

export const productLineTitle = "Product Line";
export const productLineContent = [
  [
    {
      title: "Product Line",
      text: "Sweater, Pullover, Cardigan, Scarf, Caps, for Men’s /Women’s /Ladies /Girls /Boys, in Basic & Jacquard Design & Fancy styles.",
    },
    {
      title: "Familiar with Types of Yarn",
      text: "100% Cotton, Acrylic, Cashmere like, Rayon, Acrylic Cotton Like, Wool, Viscose, Chenille Acrylic Smiling, Tube yarn & Roving, 50% Acrylic 50% Wool, Cotton Mélange, 60%cotton 40% wool, 70% acrylic 30% wool, all Kind of fancy yarn.",
    },
  ],
  [
    {
      title: "Yarn Sourcing Area (Local)",
      text: "Dayue Bangladesh Ltd., Queen South, Kung King, Ring Shine, Labib Dyeing, Nice Cotton, Fare Trade, Color Master, Shepherd etc.",
    },
    {
      title: "Yarn Sourcing Area (Foreign)",
      text: "Bros, Huafu, UPW, FiliVivi, Jiansghu Gotai, Lugang, Ferney, Filcom etc.",
    },
  ],
];

export const OurCustomersPrimeSweaterLTDImages = [
  [VertbaudetLogo, OrchestraLogo, SferaLogo, OfftexLogo, CarryLogo, HemaLogo],
  [
    FlorealParisLogo,
    DanJohnLogo,
    DooaLogo,
    Emporio88Logo,
    PiazaItaliaLogo,
    ZebraLogo,
  ],
  [
    MisterladyLogo,
    JeansLogo,
    JohnLewisLogo,
    SorbinoLogo,
    SuvariLogo,
    CorsoDaLogo,
    JeronimoLogo,
  ],
];
